import * as React from "react";

export const MultilineString: React.ComponentType<{ readonly text: string }> = function MultilineString({ text }) {
	return (
		<>
			{text
				.trim()
				.split("\\n")
				.flatMap((x, i) => [<br key={i} />, x])
				.slice(1)}
		</>
	);
};
